import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { CALENDAR_PATH } from "../../../constants";
import useRouteSwitch from "./useRouteSwitch";

const RouteSwitch = ({ toggleSlideOut }) => {
  const { routeList, currentUser } = useRouteSwitch();
  return (
    <Switch>
      {/** Must be placed at the top */}
      <Route exact path="/">
        <Redirect to={CALENDAR_PATH} />
      </Route>

      {routeList?.map(({ path, Component, exact }) => (
        <Route key={path} path={path} exact={exact}>
          <Component
            toggleSlideOut={toggleSlideOut}
            // TODO: To be removed - Do not rely on this prop
            currentUser={currentUser}
          />
        </Route>
      ))}
    </Switch>
  );
};

export default RouteSwitch;
